import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import PartnersMarquee from "@/components/shared/PartnersMarquee";
import ScrollProgress from "@/components/shared/ScrollProgress";
import { useSiteTracking } from "@/hooks/useSiteTracking";
import { useAnalytics } from "@/hooks/useAnalytics";
import { OrderRequestProvider } from "@/contexts/OrderRequestContext";
import FloatingActions from "./FloatingActions";

export default function Layout() {
  useSiteTracking();
  useAnalytics();
  const { pathname } = useLocation();
  const hidePartners = pathname.startsWith("/shop");
  return (
    <OrderRequestProvider>
      <div className="flex min-h-screen flex-col">
        <ScrollProgress />
        <Header />
        <main className="flex-1">
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </main>
        {!hidePartners && <PartnersMarquee />}
        <Footer />
        <FloatingActions />
      </div>
    </OrderRequestProvider>
  );
}
